import { useEffect, useState } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { FiMenu, FiX, FiDownload } from "react-icons/fi";
import { profile } from "../../data/portfolio";
import styles from "./Navbar.module.css";

const links = [
  { to: "#home", label: "Home" },
  { to: "#about", label: "About" },
  { to: "#experience", label: "Experience" },
  { to: "#projects", label: "Work" },
  { to: "#skills", label: "Skills" },
  { to: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const close = () => setOpen(false);

  return (
    <>
      <header className={`${styles.header} ${scrolled || open ? styles.scrolled : ""}`}>
        <nav className={styles.nav}>
          <Link smooth to="#home" className={styles.brand} onClick={close}>
            Barsa<span>.</span>
          </Link>

          <ul className={styles.desktop}>
            {links.map((link) => (
              <li key={link.to}>
                <Link smooth to={link.to}>
                  {link.label}
                </Link>
              </li>
            ))}
            <li>
              <a className={styles.resume} href={profile.links.resume} download="Barsa_Rani_Ojha_Resume">
                Resume <FiDownload />
              </a>
            </li>
          </ul>

          <button
            className={styles.menuBtn}
            type="button"
            aria-expanded={open}
            aria-label={open ? "Close menu" : "Open menu"}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <FiX size={22} /> : <FiMenu size={22} />}
          </button>
        </nav>
      </header>

      <div className={`${styles.mobile} ${open ? styles.mobileOpen : ""}`} aria-hidden={!open}>
        <div className={styles.mobileInner}>
          {links.map((link) => (
            <Link key={link.to} smooth to={link.to} onClick={close}>
              {link.label}
            </Link>
          ))}
          <a
            className={styles.resume}
            href={profile.links.resume}
            download="Barsa_Rani_Ojha_Resume"
            onClick={close}
          >
            Resume <FiDownload />
          </a>
        </div>
      </div>
    </>
  );
}
